import EventEmitter from 'events'
class MyEmitter extends EventEmitter {}
const myEmitter = new MyEmitter()
myEmitter.setMaxListeners(20)
export default myEmitter